/**
 * Agenda lists in chat.
 * Opening shows this week. «Was steht an?» shows the next 60 days,
 * then one control reveals everything still ahead.
 */

export const CHAT_AGENDA_EXTEND_LABEL = "Alle anzeigen";

/**
 * @param {object[]} items rows already in the visible window
 * @param {object[]} [moreItems] rows past that window
 * @param {{ extended?: boolean }} [opts]
 */
export function visibleAgendaItems(items, moreItems, { extended = false } = {}) {
  const list = Array.isArray(items) ? items : [];
  const more = Array.isArray(moreItems) ? moreItems : [];
  if (!extended || more.length === 0) {
    return { visible: list, remaining: more.length };
  }
  return { visible: [...list, ...more], remaining: 0 };
}

/**
 * Which rows a chat agenda card should render.
 * `extendAgenda` («Was steht an?») starts at the two-month slice.
 * `expandAgenda` (a saved mail or flyer) shows that message's rows in full.
 * @param {{ extendAgenda?: boolean, expandAgenda?: boolean, agendaExtractionId?: string }} msg
 * @param {{ items?: object[], recallItems?: object[], allItems?: object[] }} agenda
 */
export function resolveChatAgendaLists(msg, agenda) {
  const extractionId = msg?.agendaExtractionId;
  const match = (item) =>
    !extractionId ||
    item.extractionId === extractionId ||
    item.sourceId === extractionId;

  if (msg?.extendAgenda) {
    const items = (agenda?.recallItems || []).filter(match);
    const shown = new Set(items.map((item) => item.key));
    const hidden = new Set(agenda?.calendarTwinKeys || []);
    const moreItems = (agenda?.allItems || []).filter(
      (item) => match(item) && !shown.has(item.key) && !hidden.has(item.key) && !item.readOnly,
    );
    return { items, moreItems };
  }

  const base = msg?.expandAgenda ? agenda?.allItems : agenda?.items;
  return {
    items: (base || []).filter(match),
    moreItems: [],
  };
}
